export default __webpack_public_path__ + "static/spotify-f9221a768aa13af62f9f992b0c5f520a.png";